import styled from "styled-components";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";


export const ForgotPageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 808px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  margin: 0 auto 30px;
  background-color: ${Colors.softGreyColor};

  @media ${deviceMax.tablet} {
    background-color: transparent;
  }
`;

export const ForgotPageContent = styled.div`
  position: relative;
  width: 100%;
  max-width: 431px;
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 20px 0;

  @media ${deviceMax.tablet} {
    padding: 70px 0 0 0;
  }
`;

export const ForgotPageTitle = styled.h1`
  position: relative;
  color: ${Colors.black};
  margin-bottom: 0;
  margin-top: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 55px;
  letter-spacing: 0;
  text-align: left;
  text-transform: uppercase;

`;

export const ForgotPageTitleLink = styled.span`
  position: relative;
  color: ${Colors.softBlackColor};
  font-size: 18px;
  font-weight: 800;
  line-height: 55px;
  letter-spacing: 0;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  text-transform: uppercase;

  @media ${deviceMax.tablet} {
    display: none;
  }
`;

export const ForgotPageForm = styled.form`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.white};
  padding: 11px 14px 20px 17px;
  border-radius: 6px;
  margin-bottom: 21px;

  > div {
    &:nth-child(2) {
      width: 100%;
      padding: 0;

      @media ${deviceMax.tablet} {
        background-color: transparent;
        margin-bottom: 10px;
      }
    }
  }

  @media ${deviceMax.tablet} {
    background-color: transparent;
    padding: 0;
  }
`;

export const ForgotPageFormTriangle = styled.span`
  position: absolute;
  top: -30px;
  left: 20px;
  width: 0;
  height: 0;
  border-bottom: 30px solid ${Colors.white};
  border-left: 30px solid transparent;
  border-right: 30px solid transparent;

  @media ${deviceMax.tablet} {
    display: none;
  }
`;


export const StyledForgotButton = styled.div`
  position: relative;

  > div {
    display: block;
    padding: 0;
    margin-bottom: 0;
  }
`;

export const StyledForgotLine = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${Colors.black};
  margin-top: 24px;
  margin-bottom: 11px;

  @media ${deviceMax.tablet} {
    display: none;
  }
`;

export const NotMemberYet = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;

  @media ${deviceMax.tablet} {
    margin-bottom: 0;
    margin-top: 30px;
    background-color: ${Colors.white};
    padding-top: 30px;
    padding-left: 25px;
    padding-right: 25px;
    border-radius: 10px;
  }

  @media ${deviceMax.mobileL} {
    width: calc(100% + 50px);
    margin-left: -25px;
    border-radius: 0;
  }

  > div {

    &:nth-child(1) {
      background: unset;
      border-radius: unset;
      padding: 0;

      > h2 {
        margin: 0;
        text-transform: uppercase;
        color: ${Colors.black};

        @media ${deviceMax.tablet} {
          width: 100%;
          text-align: center;
        }
      }

      > p {
        margin-top: 4px;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: 0;
        color: ${Colors.black};

        @media ${deviceMax.tablet} {
          margin-top: 7px;
          text-align: center;
        }
      }
    }

    &:nth-child(2) {
      padding: 0;
      margin-top: 30px;

      @media ${deviceMax.tablet} {
        display: block;
      }

      > a {
        background-color: ${Colors.softPinkColor};

        &:hover {
          background-color: ${Colors.brandColor};
        }

        @media ${deviceMax.tablet} {
          background-color: ${Colors.black};
        }
      }
`;



export const ForgotPassword2Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 808px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  margin: 0 auto 30px;
  background-color: ${Colors.softGreyColor};

  @media ${deviceMax.tablet} {
    background-color: transparent;
  }
`;

export const ForgotPassword2Content = styled.div`
  position: relative;
  width: 100%;
  max-width: 465px;
  height: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 20px;

  @media ${deviceMax.tablet} {
    padding: 70px 0 25px;
  }
`;

export const TitleComp = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  @media ${deviceMax.tablet} {
    justify-content: center;
    margin-bottom: 0;
  }
`;

export const ForgotPassword2Title = styled.h1`
  position: relative;
  color: ${Colors.black};
  margin-bottom: 0;
  margin-top: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 55px;
  letter-spacing: 0;
  text-align: left;
  text-transform: uppercase;

`;

export const ForgotPassword2Detail = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.white};
  padding: 47px 30px 92px;
  border-radius: 6px;
  margin-bottom: 20px;

  > div {
    :is(:nth-child(2)) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding: 0;

      > h2 {
        font-weight: 800;
        font-size: 18px;
        line-height: 30px;
        text-align: center;
        letter-spacing: 0;
        color: ${Colors.black};
        margin-top: 0;
        margin-bottom: 40px;
        width: 100%;
        max-width: 210px;

        @media ${deviceMax.tablet} {
          font-size: 16px;
          line-height: 24px;
          font-weight: 600;
          margin-bottom: 10px;
        }
      }

      @media ${deviceMax.tablet} {
        background-color: transparent;
        margin-bottom: 10px;
      }
    }
  }

  @media ${deviceMax.tablet} {
    background-color: transparent;
    padding: 0;
  }
`;

export const ForgotPassword2FormTriangle = styled.span`
  position: absolute;
  top: -30px;
  left: 20px;
  width: 0;
  height: 0;
  border-bottom: 30px solid ${Colors.white};
  border-left: 30px solid transparent;
  border-right: 30px solid transparent;

  @media ${deviceMax.tablet} {
    display: none;
  }
`;


export const ForgotPassword2Icon = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

  > img {
    width: 100%;
    max-width: 100px;
  }
`;

export const ReturnHomePageButton = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

  > div {
    display: block;
    padding: 0;
    margin-bottom: 0;

    @media ${deviceMax.tablet} {

      > a {
        background-color: ${Colors.black};

      }
    }
  }
`;
